/**
 * QuoteDetailTour (iter150AZ.42) — coachmark walkthrough for the
 * Quote Detail page (`/quote/:id`).
 *
 * Steps cover:
 *   1. Title + status chip
 *   2. Download PDF button
 *   3. Line items table
 *   4. Share-link / dealer workflow bar
 *   5. Totals + per-quote discount controls (admin only)
 *
 * Auto-runs the first time the user opens any quote; re-launchable
 * via the Help button next to the title.
 */
import { useState } from "react";
import { useT } from "@/lib/i18n";
import GuidedTour, { TourHelpButton } from "@/components/GuidedTour";

const STORAGE_KEY = "tour_quote_detail_v1";

function buildSteps(t) {
  return [
    {
      target: '[data-tour="quote-header"]',
      content: t("tour.qd.header",
        "Welcome to the Quote Detail page. The header carries the quote number, current status, and payment chip."),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-testid="quote-download-pdf"]',
      content: t("tour.qd.pdf",
        "Download the Proforma Invoice as a branded PDF — ready to email a customer."),
      placement: "bottom",
    },
    {
      target: '[data-tour="quote-lines"]',
      content: t("tour.qd.lines",
        "Line items. Admins and the preparer can edit qty, price, and per-line discount inline."),
      placement: "top",
    },
    {
      target: '[data-tour="quote-totals"]',
      content: t("tour.qd.totals",
        "Totals live here. Admins can set a flat quote-level discount OR a final-total target — the system reverse-solves the discount for you."),
      placement: "top",
    },
  ];
}

export default function QuoteDetailTour({ runFlag, onFinish }) {
  const t = useT();
  const [steps] = useState(() => buildSteps(t));
  return <GuidedTour steps={steps} storageKey={STORAGE_KEY}
                     runFlag={runFlag} onFinish={onFinish} />;
}

export { TourHelpButton };
